module.exports = __webpack_public_path__ + "img/gc_country_flag_us.7a100356.svg";